import { render, staticRenderFns } from "./SummaryCell.vue?vue&type=template&id=52a4595c&"
import script from "./SummaryCell.vue?vue&type=script&lang=js&"
export * from "./SummaryCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports